import type { SyntheticEvent } from "react";
import { fold, fromNullable } from "fp-ts/lib/Option";

export const escapeKeys = ["Escape", "Esc"];

export const isEscKeyPress = (event: SyntheticEvent<HTMLElement, KeyboardEvent>): boolean => {
  return fold(() => false, (e: KeyboardEvent) => escapeKeys.includes(e.key))(fromNullable(event.nativeEvent));
};
